import { QueryKeys } from "@/constants/Query";
import type { PatientTabsResponse } from "@/features/PatientTabs/network/usePatientTabs";
import { isSelected } from "@/features/PatientTabs/utils";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { useNavigateLiveQueue } from "./useNavigateLiveQueue";

export const useNavigateNextPatient = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const navigateLiveQueue = useNavigateLiveQueue();

  return ({
    patientId,
    encounterId,
  }: {
    patientId: string;
    encounterId?: string;
  }) => {
    const data = queryClient.getQueryData<PatientTabsResponse>(
      QueryKeys.Provider.PATIENT_TABS,
    );
    const tabs = data?.patientTabs ?? [];

    if (tabs.length === 0) {
      navigateLiveQueue();
      return;
    }

    const currentIndex = tabs.findIndex((t) =>
      isSelected(t, patientId, encounterId),
    );

    if (tabs.length <= 1 || currentIndex < 0) {
      navigateLiveQueue();
      return;
    }

    const nextIndex =
      currentIndex < tabs.length - 1 ? currentIndex + 1 : currentIndex - 1;
    const nextTab = tabs[nextIndex];

    const search: Record<string, string> = {};
    if (nextTab.encounter?.id) {
      search.encounterId = nextTab.encounter.id;
    }

    navigate({
      to: "/patient/$patientId/timeline",
      params: { patientId: nextTab.patient.id },
      search,
    });
  };
};
